import io from "socket.io-client";
import { endpoints } from "../../api/ApiEndPoints";
import { setBalance } from "../../components/signIn/cl_SignInSlice";

let socket = null;

const GAMES_SOCKET_END_POINT = endpoints.socketUrl;

export const socketConnect = (dispatch) => {
  if (!socket) {
    socket = io(GAMES_SOCKET_END_POINT, {
      transports: ['websocket'],
    });

    socket.on('balanceupdate', function (data) {
      if (data) {
        dispatch(setBalance(data?.realBalance))
        const event = new CustomEvent('balanceUpdate', {
          detail: data,
        });
        window.dispatchEvent(event);
      }
    });

    socket.on('notification', function (data) {
      if (data) {
        const event = new CustomEvent('notification', {
          detail: data,
        });
        window.dispatchEvent(event);
      }
    });

    socket.on("connect", () => {
      console.log("Connected to socket.io server");
    });

    socket.on("error", (err) => {
      console.error("Socket error:", err);
    });

    socket.on("connect_error", (err) => {
      console.error("Socket connection error:", err);
    });

    socket.on("disconnect", (reason) => {
      console.log("Socket disconnected:", reason);
    });
  }
};

export const subscribeUserBalance = (playerId) => {
  if (socket && playerId) {
    try {
      socket.emit(
        "subscribe",
        JSON.stringify({ event: "balanceupdate", data: { token: playerId } })
      );
    } catch (err) {
      console.error(err.toString());
    }
  }
};

export const unSubscribeUserBalance = (playerId) => {
  if (socket && playerId) {
    try {
      socket.emit(
        "unsubscribe",
        JSON.stringify({ event: "balanceupdate", data: { token: playerId } })
      );
    } catch (err) {
      console.error(err.toString());
    }
  }
};
